import { Search } from 'blaze-ui/icons'
import Styles from './DesignAspectRatioPickerModal.module.scss'

import { SearchFieldProps } from './Types'
import { Input } from 'almanac-ui/TextInputField/Input'

const SearchField = ({ placeholder = 'Search', onChange, value }: SearchFieldProps) => {
  return (
    <div className={Styles.searchField}>
      <Search />
      <Input
        className={Styles.searchInput}
        name="search"
        autoFocus
        id="mediaUploadSearchForm"
        type="text"
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
        placeholder={placeholder}
        autoComplete="off"
        aria-label="Search Form Input"
        withBorder={false}
      />
    </div>
  )
}

export { SearchField }
